export default {
  about: 'About',
  addOns: 'Add-ons',
  agenda: 'Agenda',
  all: 'All',
  arrival: 'Arrival',
  at: 'at',
  availableTimes: 'Available times',
  browse: 'Browse',
  buyTickets: 'Buy tickets',
  cancellationPolicy: 'Cancellation policy',
  checkOutOutOtherExperiences: 'Check out our other experiences!',
  continue: 'Continue',
  countSelected: '{{count}} selected',
  departure: 'Departure',
  from: 'from',
  included: 'Included',
  joinWaitlist: 'Join Waitlist',
  joining: 'Joining',
  location: 'Location',
  menu: 'Menu',
  nights: 'nights',
  noDatesAvailable: 'No dates available',
  noTimesAvailableOnThisDateFotThisPartySize:
    'No times available on this date for this party size',
  request: 'Request',
  rsvp: 'RSVP',
  salesEnded: 'Sales ended',
  schedule: 'Schedule',
  seeMoreDates: 'See more dates',
  soldOut: 'Sold out',
  tickets: 'Tickets',
  ticketsAreNoLongerAvailable: 'Tickets are no longer available.',
  time: 'Time',
  viewExperiences: 'View experiences',
  viewLess: 'View less',
  viewMore: 'View more',
  waitlist: 'Waitlist',
};
